module.exports = "<div ng-if=\"vm.shouldShowBlurb\" class=\"app__background sb-help-blurb__blurb-container\" layout=\"column\" layout-padding>\n\t<div class=\"sb-help-blurb__blurb-text\">\n\t\t{{vm.blurb.text}}\n\t</div>\n\t<div layout=\"row\" layout-align=\"end end\">\n\t\t<md-button class=\"md-primary md-raised\" ng-click=\"vm.hideBlurb()\">\n\t\t\t{{::'Got it' | translate}}\n\t\t</md-button>\n\t</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/sharebase/components/help-blurb/help-blurb.template.html
// module id = 1069
// module chunks = 0